import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  Fragment,
} from "react";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Button,
  Checkbox,
  Form,
  Icon,
  Spin,
  Modal,
  Skeleton,
  Tabs,
} from "antd";
import RecoveryDataTab from "../recoveries/RecoveryDataTab";
import ReleaseDataTab from "../releases/ReleaseDataTab";
import { OrgContext } from "../../context/OrgContext";
import { base64ToPDF, checkAccessExistance, checkServiceExistance } from "../../helpers/common";
import Invoice from "../billing/Invoice";
import EstimateBillingDetails from "../../stories/components/EstimateBillingDetails";
import BillOfRatingModal from "../../containers/BillOfRatingModal";
import { fetchBolPdf } from "../../api/BillingScreenAPI";
import { alertMessage, isEmpty, randomNumber } from "../../common/Common";
import OrderExceptions from "../orders/OrderExceptions";
import ViewOrderScreen from "../../stories/components/ViewOrderScreen";
import I18n from "../../common/I18n";
import OrderActivities from "../orders/OrderActivities";
import OrderNotifications from "../orders/OrderNotifications";
import OrderWms from "../orders/OrderWms";
import SendStatusReportComponent from "./SendStatusReport";
import Warehouse from "../../stories/components/warehouse";
import PropTypes from "prop-types";
import SubOrdersView from "../../stories/components/SubOrdersView";
import { getAccountConfigs } from "../../helpers/api_calls";
import { fetchNonBillableAccounts } from "../../api/Account";
import { isOrderAccountBillable } from "../orders/helpers";
import { fetchConsolidatedMawbs } from "../../api/OrdersApi";
import { base64ToBlob, handleDownload } from "../../common/preview";
import Adjustments from "../../stories/components/Adjustments";
import LHTracking from "../../stories/components/orders/LHTracking";
import DriverPayConfiguration from "./DriverPayConfiguration";
import RouteTracker from "../../stories/components/LhTrackingNew/RouteTracker";
import OrderPickupDriverPay from "./OrderPickupDriverPay";


const { confirm } = Modal;
const { TabPane } = Tabs;
const OrderDetailsTabsInfo = (props) => {
  const { 
    currentOrg, orderResponse, refreshDetails, organizationSettings, isDeletedOrder = false, currentRoute,
    isShipper , isMilitaryTime, fromIndividualScreen, currentPreplan, account,
    activeKey, setActiveKey, goToTab, setOutofPreplan, setIsModified, consolidatedData = [], setIsOrderDownloadModalOpen = () => { }, setBlobData = () => { }, updateLocationDetails, updateDurationDetails, updateReceivedDetails, updateDeliverByDetails, updateAppointmentDetails, updateActualDetails, updateConsigneeName, updateConsigneePhone, updateConsigneeAddress, updatePickupByDetails, updateOnHandDetails, updateOutboundDockDetails, screenFrom,
    refreshLhTracking = false, onLhTrackingRefreshed, onLinehaulTrackingRefresh,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

  // const [activeKey, setActiveKey] = useState('overview');
  const showActions = !isShipper
  const [config, setConfig] = useState({}) 
  const [isAccountNonBillable, setIsAccountNonBillable] = useState(false)
  const [isCheckingBillability, setIsCheckingBillability] = useState(false)

  // Refresh the order details once when leaving the Estimate tab IF the LoS was
  // changed there, so the Details tab reflects the new LoS — not on every switch.
  const losChangedInEstimateRef = useRef(false);
  const handleTabChange = (key) => {
    if (activeKey === "billing" && losChangedInEstimateRef.current) {
      losChangedInEstimateRef.current = false;
      refreshDetails();
    }
    goToTab(key);
  };
  // TEMP verification toggle: new embedded BillingScreen estimate vs legacy Invoice screen.
  // Persisted per-browser; default new. Remove once verified.
  const [useNewEstimateBilling, setUseNewEstimateBilling] = useState(() => {
    try {
      return localStorage.getItem("useNewEstimateBilling") !== "false";
    } catch (e) {
      return true;
    }
  });
  const toggleEstimateUi = (checked) => {
    try {
      localStorage.setItem("useNewEstimateBilling", checked ? "true" : "false");
    } catch (e) {
      /* ignore storage errors */
    }
    setUseNewEstimateBilling(checked);
  };
  
 const printBol = (type = "print") => {
   setIsGeneratingPdf(true)
   setIsOrderDownloadModalOpen(true)
   const currentOrder = _.cloneDeep(orderResponse);
    fetchBolPdf(currentOrder.id)
        .then((result) => {
          if (result.success) {
            // base64ToPDF(
            //     result.bol_file,
            //     `OrderBol${currentOrder.id}.pdf`
            // );
            const fileName = `Order_Bol_${currentOrder.customer_order_number}.pdf`;
            const blob = base64ToBlob(result.bol_file, 'application/pdf');
            const blobUrl = URL.createObjectURL(blob);
            if(type === "download"){
              handleDownload(blobUrl, fileName);
            } else {
              setBlobData({
                blobUrl: blobUrl,
                fileName: fileName,
              });
            }
          } else {
            alertMessage("failed to generate pdf","error", 10)
          }
        })
        .finally(() => {
          setIsGeneratingPdf(false)
        });
  }


useEffect(() => {
  if (orderResponse?.account?.account_id) {
    fetchAccountConfig()
  }
},[orderResponse])

useEffect(() => {
  if (activeKey !== "billing") {
    return;
  }

  const orgId = orderResponse?.customer_order_details?.organization_id || currentOrg?.id;
  if (!orgId) {
    setIsCheckingBillability(false);
    setIsAccountNonBillable(false);
    return;
  }

  setIsCheckingBillability(true);
  setIsAccountNonBillable(false);
  fetchNonBillableAccountsList(orgId);
}, [activeKey, orderResponse?.id, currentOrg?.id])

  const fetchAccountConfig = async() => {
    try {
        const result = await getAccountConfigs(orderResponse?.account?.account_id, orderResponse?.customer_order_details?.organization_id || currentOrg?.id);
        if (result.success) {
          setConfig(result.data || {})         
        }
        // Use the fetched data here
      } catch (error) {
        console.error('Error using fetched data:', error);
      }  
    }

  const fetchNonBillableAccountsList = async (orgId) => {
    try {
      const result = await fetchNonBillableAccounts(orgId);
      if (result.success) {
        const orderAccount = orderResponse?.account || {
          account_id: orderResponse?.account?.account_id,
          account_code: orderResponse?.account?.account_code || orderResponse?.account_code,
        };
        setIsAccountNonBillable(
          !isOrderAccountBillable(orderAccount, result.accounts)
        );
      }
    } catch (error) {
      console.error("Error fetching non-billable accounts:", error);
    } finally {
      setIsCheckingBillability(false);
    }
  };

  const EmptyNonBillableState = () => (
    <div className="emptyDisplay">
      <div className="empty-tracking-state">
        <div className="empty-state-container">
          <div className="empty-state-icon">
            <Icon type="info-circle" />
          </div>
          <div className="empty-state-content">
            <h3 className="empty-state-title">
              {I18n.t("order.billing_not_enabled_title")}
            </h3>
            <p className="empty-state-description">
              {I18n.t("order.billing_not_enabled_message")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );

   const setting= config?.consolidated_mawbs === "true"

  const renderTabs = () => {
    const currentOrder = _.cloneDeep(orderResponse);
    const type_of_order = _.get(orderResponse, "customer_order_details.type_of_order", "");
    return (
      <Tabs
        data-testid="order-view-tabs"
        className="order-view-tab-bar"
        key={currentOrder?.id}
        size="small"
        onChange={handleTabChange}
        activeKey={activeKey}
        // tabBarExtraContent={
        //   <Row
        //     type="flex"
        //     style={{
        //       display: "flex",
        //       gap: "10px",
        //       alignItems: "center",
        //       padding: "0 10px",
        //     }}
        //   >
        //     {currentOrder?.pdf_response?.response && (
        //       <Col>
        //         <MiscData
        //           pdf_response={currentOrder.pdf_response}
        //           position={{ x: -400, y: 0 }}
        //         />
        //       </Col>
        //     )}
        //     {!currentOrder.is_location_based && (
        //       <Col className="serviceDurationDetail">
        //         {this.renderServiceDuration(currentOrder)}
        //       </Col>
        //     )}
        //     <Col>
        //       <OrderStatus
        //         record={currentOrder}
        //         displayKey="status"
        //         label=""
        //         showLabel={false}
        //         className="textBold textPrimary"
        //         displayType="button"
        //         popoverMsg={
        //           exceptionsInDesc.length > 0
        //             ? exceptionsInDesc[0].exception_message
        //             : currentOrder.status === "ON_HOLD" &&
        //               currentOrder.on_hold_reason
        //             ? currentOrder.on_hold_reason
        //             : ""
        //         }
        //       />
        //     </Col>
        //   </Row>
        // }
      >
        <TabPane tab="Overview" key="overview" className="">
          {isEmpty(orderResponse) || isEmpty(orderResponse.id) ? (
            <Skeleton active />
          ) : (
            <ViewOrderScreen 
              orderResponse={orderResponse} 
              doRefreshDetails={refreshDetails}
              updateLocationDetails={updateLocationDetails}
              updateDurationDetails={updateDurationDetails}
              updateReceivedDetails={updateReceivedDetails}
              updateDeliverByDetails={updateDeliverByDetails}
              updateAppointmentDetails={updateAppointmentDetails}
              updateActualDetails={updateActualDetails}
              updateConsigneeName={updateConsigneeName}
              updateConsigneePhone={updateConsigneePhone}
              updateConsigneeAddress={updateConsigneeAddress}
              currentPreplan={currentPreplan}
              setOutofPreplan={setOutofPreplan}
              setIsModified={setIsModified}
              currentRoute={currentRoute}
              consolidatedData={consolidatedData}
              showActions={showActions}
              setEstimateRefreshKey={props.setEstimateRefreshKey}
              updateItemDetails={props.updateItemDetails}
              updatePickupByDetails={updatePickupByDetails}
              updateOnHandDetails={updateOnHandDetails}
              updateOutboundDockDetails={updateOutboundDockDetails}
              screenFrom={screenFrom}
              setActiveKey={setActiveKey}
              refreshLhTracking={refreshLhTracking}
              onLhTrackingRefreshed={onLhTrackingRefreshed}
              onLinehaulTrackingRefresh={onLinehaulTrackingRefresh}
            />
          )}
        </TabPane>
        {showActions && !isDeletedOrder && setting && consolidatedData?.length > 0
        && (
          <TabPane tab="Sub Orders" key="subOrders" className="newOrderDetailScroll">
            <div className="appointmentForm" style={{padding:'16px 0'}}>
              <div style={{
                maxHeight: fromIndividualScreen
                  ? "calc(80vh - 230px)"
                  : "calc(90vh - 150px)",
                overflowY: "auto",
              }}>

            <SubOrdersView
            consolidatedData={consolidatedData}
            orderResponse={orderResponse} 
            doRefreshDetails={refreshDetails}
            setActiveKey={setActiveKey}
            />
              </div>
              {/* <Invoice
                order={currentOrder}
                order_id={currentOrder.id}
                callInvoceDetails={true}
                showHeading={false}
                showOtherDetails={false}
                updateQuote={(id, amount) =>
                  // this.updateQuote(id, amount, details.key)
                  refreshDetails()
                }
                setData={false}
                activeKey={activeKey}
              /> */}
            </div>
          </TabPane>
        )}

        {showActions && checkServiceExistance("OEA") && !isDeletedOrder && (
         <TabPane tab="Estimate" key="billing" className="newOrderDetailScroll order_details_est_blk">
         <div data-testid="estimate-view" className="appointmentForm" style={{ padding: '16px 0' }}>
           <div
             style={
               // Own the scroll here (context-aware height) for BOTH UIs. The new
               // estimate neutralises FormInvoice's internal .billing_indv scroll,
               // so there's no double scrollbar — and unlike relying on the
               // ancestor .newOrderDetailScroll (100vh based), this also scrolls
               // when the order is opened from the billing / individual (drawer)
               // context where that ancestor isn't the real scroll parent.
               {
                 maxHeight: fromIndividualScreen
                   ? "calc(80vh - 230px)"
                   : "calc(90vh - 150px)",
                 overflowY: "auto",
               }
             }
           >
            {activeKey === "billing" && (
              isCheckingBillability ? (
                <Skeleton active paragraph={{ rows: 8 }} />
              ) : isAccountNonBillable ? (
                <EmptyNonBillableState />
              ) : (
              (() => {
                // TEMP verification switch (remove once decided): choose the new
                // embedded BillingScreen estimate or the legacy Invoice screen.
                const EstimateComponent = useNewEstimateBilling
                  ? EstimateBillingDetails
                  : Invoice;
                return (
                  <Fragment>
                    <div style={{ textAlign: "right", marginBottom: 8 }}>
                      <Button
                        size="small"
                        type={useNewEstimateBilling ? "primary" : "default"}
                        onClick={() => toggleEstimateUi(!useNewEstimateBilling)}
                      >
                        {useNewEstimateBilling ? "New Estimate UI" : "Old Estimate UI"} (click to switch)
                      </Button>
                    </div>
                    <EstimateComponent
                      order={currentOrder}
                      order_id={currentOrder.id}
                      callInvoceDetails={true}
                      showHeading={false}
                      showOtherDetails={false}
                      //updateQuote={(id, amount) => refreshDetails()}
                      setData={false}
                      activeKey={activeKey}
                      updateQuote={() => props.setEstimateRefreshKey(randomNumber())}
                      onLosChanged={() => {
                        // FormInvoice calls this on a LoS change / regenerate (with
                        // true when APPROVED, false after the auto-reGenerate on
                        // non-approved). Either way the LoS was touched, so mark
                        // dirty and refresh details once on leaving the tab.
                        losChangedInEstimateRef.current = true;
                      }}
                      canEdit={checkAccessExistance("ESTIMATE_EDIT")}
                    />
                  </Fragment>
                );
              })()
              )
             )}
           </div>
         </div>
       </TabPane>
       
        )}
        {showActions && !isDeletedOrder && (
          <TabPane
            tab="Tracking"
            key="tracking"
            className="padding10 detailsSection"
          >
            <div style={{padding:"15px"}}>
            <RouteTracker  orderResponse={orderResponse} activeKey={activeKey} />
            </div>
            {/* <LHTracking
             orderResponse={orderResponse}
            /> */}
          </TabPane>
        )}

        {showActions && checkServiceExistance("OEA") && !isDeletedOrder && (
          <TabPane tab="Adjustments" key="adjustments" className="newOrderDetailScroll">
            <div data-testid="adjustments-view" style={{ padding: '16px 16px' }}>
              <div
                style={{
                  maxHeight: fromIndividualScreen
                    ? "calc(80vh - 230px)"
                    : "calc(90vh - 150px)",
                  // overflowY: "auto",
                }}
              >
               <Adjustments
              orderResponse={orderResponse}
              account={account}
              refreshDetails={refreshDetails}
              setEstimateRefreshKey={props.setEstimateRefreshKey}
            />
                </div>
                </div>
              </TabPane>
              )}

        {showActions && checkServiceExistance("OEA") && !isDeletedOrder && (
          <TabPane tab="Driver Pay Configuration" key="driverPayConfig" className="newOrderDetailScroll">
            <div style={{ padding: '16px 16px' }}>
              <div
                style={{
                  maxHeight: fromIndividualScreen
                    ? "calc(80vh - 230px)"
                    : "calc(90vh - 150px)",
                  overflowY: "auto",
                }}
              >
                <OrderPickupDriverPay
                  orderResponse={orderResponse}
                  account={account}
                  isLocked={isDeletedOrder}
                />
                <DriverPayConfiguration
                  orderResponse={orderResponse}
                  account={account}
                  refreshDetails={refreshDetails}
                  activeKey={activeKey}
                />
              </div>
            </div>
          </TabPane>
        )}
       
        {showActions && checkServiceExistance("OBLR") && !isDeletedOrder && (
          <TabPane
            tab={I18n.t("BillOfRating.bill_of_rating_title")}
            key="bol"
            className="newOrderDetailScroll"
          >
                <div  style={{
                  maxHeight: fromIndividualScreen
                 ? "calc(80vh - 230px)"
                 : "calc(90vh - 150px)",
                 overflowY: "auto",
                }}>
            <div className="appointmentForm" style={{borderRadius: "8px", padding: "24px", margin: "20px 10%", backgroundColor: "white", boxShadow: "0 24px 64px 0 rgba(0, 0, 0, 0.16)"}}>
               <Spin spinning={isGeneratingPdf} delay={1000}>
                <BillOfRatingModal
                  organizationSettings={organizationSettings}
                  orderId={currentOrder.id}
                  currentOrder={currentOrder}
                  order={_.pick(currentOrder.customer_order_details, ["hawb", 'nawb', "organization_id", "type_of_order"])}
                  handlePrint={printBol}
                  currentOrg={currentOrg}
                  setIsOrderDownloadModalOpen={setIsOrderDownloadModalOpen}
                />
              </Spin>
                </div>
            </div>
          </TabPane>
        )}
        {/* {currentOrder.is_lh_order && !isDeletedOrder && (
          <TabPane
            tab={I18n.t("linehaul.label")}
            key="linehaul"
            className="padding10 detailsSection orderDetailScroll"
          >
            <Row gutter={16}>
              <Col xs={24}>
                <LhDetails
                  order_id={currentOrder.linehaul_id}
                  actionType="view"
                  isMilitaryTime={this.state.isMilitaryTime}
                />
              </Col>
            </Row>
          </TabPane>
        )} */}
        {/* {
              // type_of_order != 'T' &&
              showActions && checkServiceExistance('ORD') &&
                ['R', 'D', 'TR'].includes(currentOrder.type_of_order) && (
                    <TabPane
                        tab={I18n.t('recoveries.label')}
                        key="recoveries"
                        className="padding10 detailsSection orderDetailScroll"
                    >
                      <Row gutter={16}>
                        <Col xs={24}>
                          <RecoveryManage
                              order_id={currentOrder.id}
                              actionType="view"
                              // timeZoneId={currentOrder.order_timeZoneId}
                              typeOfOrder={currentOrder.type_of_order}
                          />
                        </Col>
                      </Row>
                    </TabPane>
                )}
            { showActions && !['M', 'T'].includes(currentOrder.type_of_order) && checkServiceExistance('ORED') && (
                <TabPane
                    tab={I18n.t('releases.label')}
                    key="releases"
                    className="padding10 detailsSection orderDetailScroll"
                >
                  <Row gutter={16}>
                    <Col xs={24}>
                      <ReleaseManage
                          order_id={currentOrder.id}
                          actionType="view"
                          timeZoneId={currentOrder.order_timeZoneId}
                          account_id={currentOrder.account_id}
                          org_id={ currentOrder.organization_id }
                      />
                    </Col>
                  </Row>
                </TabPane>
            )} */}
        {showActions && !isDeletedOrder && (
          <TabPane
            tab={I18n.t("exceptions.log")}
            key="exceptions"
            // className="padding10"
          >
            <div style={{
              maxHeight: fromIndividualScreen
                ? "calc(80vh - 230px)"
                : "calc(90vh - 150px)",
              overflowY: "auto",
            }}>
               <OrderExceptions 
                  currentOrder={_.pick(currentOrder.customer_order_details, ["id" , "timeZoneId", 'tz_short_name', "organization_id", "type_of_order" ])}
                  fromIndividualScreen={props.fromIndividualScreen}
                  isMilitaryTime={isMilitaryTime}
                  currentOrg={currentOrg}

                  
               />
           </div>
             
          </TabPane>
        )}
        {showActions && (
          <TabPane
            tab={I18n.t("order.activities")}
            key="activities"
            className="order-activities-tab"
            style={{padding: '16px'}}
          >
            {/* <this.renderActivities /> */}
            <OrderActivities
                currentOrder={_.pick(currentOrder.customer_order_details, ["id" , "timeZoneId", 'tz_short_name', "organization_id", "type_of_order" ])}
                fromIndividualScreen={props.fromIndividualScreen}
                isMilitaryTime={isMilitaryTime}
                currentOrg={currentOrg}
                activeKey={activeKey}

                  
            />
          </TabPane>
        )}
        {showActions && !isDeletedOrder && (
          <TabPane
            tab={I18n.t("order.notification_log")}
            key="notification_log"
            className="detailsSection"
            style={{padding:"16px"}}
          >
             <div  style={{
                  maxHeight: fromIndividualScreen
                 ? "calc(80vh - 230px)"
                 : "calc(90vh - 150px)",
                 overflowY: "auto",
                }}>

            <Row gutter={16}>
              <Col xs={24}>
                {/* <this.renderNotification /> */}
                <OrderNotifications
                  currentOrder={_.pick(currentOrder.customer_order_details, ["id" , "timeZoneId", 'tz_short_name', "organization_id", "type_of_order" ])}
                  fromIndividualScreen={props.fromIndividualScreen}
                  isMilitaryTime={isMilitaryTime}
                  currentOrg={currentOrg}

                  
               />
              </Col>
            </Row>
                </div>
          </TabPane>
        )}
        {showActions && !isDeletedOrder && (
          <TabPane
            tab={I18n.t('general.warehouse')} //"I18n.t('order.wms')"
            key="wms"
            className="detailsSection newOrderDetailScroll"
          >
             <div  style={{
                  maxHeight: fromIndividualScreen
                 ? "calc(80vh - 230px)"
                 : "calc(90vh - 150px)",
                 overflowY: "auto",
                }}>

            <Row>
              <Col xs={24}>
                {/* <this.renderWms /> */}
                {/* <OrderWms 
                  currentOrder={_.pick(currentOrder.customer_order_details, ["id" , "order_timeZoneId", 'order_tz_short_name', "organization_id", "type_of_order" ])}
                  fromIndividualScreen={props.fromIndividualScreen}
                  isMilitaryTime={isMilitaryTime}
                  currentOrg={currentOrg}
                  
               /> */}
               <Warehouse
               currentOrder={_.pick(currentOrder.customer_order_details, ["id" , "timeZoneId", 'tz_short_name', "organization_id", "type_of_order" ])}
               fromIndividualScreen={props.fromIndividualScreen}
               isMilitaryTime={isMilitaryTime}
               currentOrg={currentOrg}
               />
              </Col>
            </Row>
                </div>
          </TabPane>
        )}
        {showActions && checkServiceExistance("SCA") && !isDeletedOrder && !currentOrder?.customer_order_details?.is_split_order && (
          <TabPane
            tab={"Connectivity"} //"I18n.t('order.wms')"
            key="send_status"
            className="detailsSection newOrderDetailScroll"
          >
             <div  style={{
                  maxHeight: fromIndividualScreen
                 ? "calc(80vh - 230px)"
                 : "calc(90vh - 150px)",
                 overflowY: "auto",
                }}>

            <Row>
              <Col xs={24}>
                {/* <SendStatusReportComponent
                  order={this.state.currentOrder}
                  order_id={this.state.currentOrder.id}
                /> */}
                <SendStatusReportComponent
                    order={{
                        ...currentOrder,
                        // source_files: [],
                        wh_location: {
                        timeZoneId: _.get(currentOrder.customer_order_details, "timeZoneId", "" ) || "",
                        tz_short_name: _.get(currentOrder.customer_order_details, "tz_short_name", "" ) || "",                      
                      }
                    }}
                    order_id={currentOrder.id}
                  />
              </Col>
            </Row>
                </div>
          </TabPane>
        )}
      </Tabs>
    );
  };

  return (
    <Spin spinning={isLoading}>
      {!orderResponse?.customer_order_details?.id ? <Skeleton /> : renderTabs()}
    </Spin>
  );
};

OrderDetailsTabsInfo.propTypes = {
  currentPreplan: PropTypes.shape(),
  currentRoute: PropTypes.shape(),
  onClose: PropTypes.func,
  setOutofPreplan: PropTypes.func,
  setIsModified: PropTypes.func,
  setEstimateRefreshKey: PropTypes.func,
  updateItemDetails: PropTypes.func,
  screenFrom: PropTypes.string

  
};
OrderDetailsTabsInfo.defaultProps = {
  currentPreplan: {},
  currentRoute: {},
  onClose: () => {},
  setOutofPreplan: () => {},
  setIsModified: () => {},
  setEstimateRefreshKey: () => {},
  updateItemDetails: () => {},
  screenFrom: "orders",
};


export default withRouter(Form.create()(OrderDetailsTabsInfo));